export default "/images/clipboard.svg?a7baf41069746e4c53c600eeb023c62c";